//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "",
  data() {
    return {
      list_ary: [],
      loading: false,
      detail_show: false,
      content: ""
    };
  },
  mounted() {
    this.loading = true;
    let formData = new FormData();
    formData.append("orderByObj", "id");
    formData.append("orderBy", "desc");
    formData.append("action_type", "no_condition");
    formData.append("form", "send_notice");

    this.$http({
      url: "/search/common.php",
      method: "post",
      data: formData
    }).then(res => {
      this.loading = false;
      this.list_ary = res.data.data;
    });
  },
  components: {},
  methods: {
    push: function(item) {
      this.content = item.content;
      this.detail_show = true;
    }
  },
  filters: {
    month_day: function(value) {
      //月日
      return value.slice(0, 10);
    },

    capitalize: function(value) {
      //周几
      return "周" + "日一二三四五六 ".charAt(new Date(value).getDay());
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/send_notice.vue